import SearchReturnsVadIvend from './SearchReturnsVadIvend'

export default SearchReturnsVadIvend
